import React, { useState, useEffect, useMemo, useRef } from "react";
import moment from "moment";
import Tooltip from "@mui/material/Tooltip";
import PDIRejectedDialog from "../../../../../components/AdminportalFolder/Campaign/RecceRejectedModal.js";
import StoreSearch from "../../../Campaign/StoreSearch.js";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Grid,
  Chip,
  Box,
  IconButton,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Menu,
  MenuItem,
  Modal,
  TextField,
  Button,
  Checkbox,
  Dialog,
  DialogContent,
  DialogActions,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import styles from "../../JobBatch.module.css";
import ModalToUpdateBatches from "../../ModalToUpdateBatches";
import axios from "axios";
import ModalToOpenEditJobs from "../../ModalToOpenEditJobs";
import CircularProgress from "@mui/material/CircularProgress";
import { useParams } from "react-router-dom";
import AddJobDialog from "../addJobModal";
import RejectModal from "../../../../../components/AdminportalFolder/Campaign/RejectModal.jsx";
import useRejectModal from "../../../Campaign/useRejectModal.js";

const AllBatches = ({
  isAllBatchesLoading,
  setAvailableBatches,
  availableBatches,
  availableJobs,
  updateJobInParent, // Add this prop
  selectedBatchIds,
  setSelectedBatchIds,
  fetchAllJobsBasedOnCampaignId,
  onIPAssignmentSuccess,
  fetchAllBatchesBasedOnCampaignId,
  // Add these props:
  setAcceptedBatches,
  setIsNotAccepted,
  productDetails,
  categoryData,

  soDetails,
  rejectJob,
  showSnackbar,
  fetchBatchById,
}) => {
  const { id } = useParams();

  const [expandedBatch, setExpandedBatch] = React.useState(null);
  const [openAddJob, setOpenAddJob] = useState(false);

  const [openModalToUpdateBatch, setOpenModalToUpdateBatch] =
    React.useState(false);
  const [detailsOfBatchSelected, setDetailsOfBatchSelected] = React.useState();
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedJob, setSelectedJob] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const batchRefs = useRef({});
  const containerRef = useRef(null);
  const [multipleSelectedJobs, setMultipleSelectedJobs] = useState([]);
  const [batchMenuAnchorEl, setBatchMenuAnchorEl] = useState(null);
  const [selectedBatch, setSelectedBatch] = useState(null);
  const [duplicatingJob, setDuplicatingJob] = useState(null);
  const [duplicatingBatchId, setDuplicatingBatchId] = useState(null);

  const itemsToRejectRef = useRef(null);

  const {
    isProcessing,
    rejectDialogOpen,
    itemInfo,
    openRejectModal,
    closeRejectModal,
    handleRejectConfirm,
  } = useRejectModal({
    onReject: async (ids, reason) => {
      await rejectJob(ids, reason);

      const jobsToReject = itemsToRejectRef?.current || [];

      const affectedBatchIds = new Set();

      jobsToReject.forEach((job) => {
        const batch = availableBatches.find((b) =>
          b?.jobs?.some((j) => j?._id === job?._id),
        );
        if (batch) {
          affectedBatchIds?.add(batch._id);
        }
      });

      // Fetch each affected batch
      const fetchPromises = Array.from(affectedBatchIds).map((batchId) =>
        fetchBatchById(batchId),
      );
      const updatedBatches = await Promise.all(fetchPromises);

      // Update state with fetched batches
      setAvailableBatches((prevBatches) =>
        prevBatches.map((batch) => {
          const updatedBatch = updatedBatches.find(
            (b) => b?._id === batch?._id,
          );
          if (updatedBatch) {
            const currentBatch = prevBatches?.find(
              (b) => b?._id === batch?._id,
            );
            return {
              ...updatedBatch,
              isPublished:
                currentBatch?.isPublished || updatedBatch?.isPublished || false,
            };
          }
          return batch;
        }),
      );

      setBatchMenuAnchorEl(null);
      setSelectedBatch(null);
      setMultipleSelectedJobs([]);
      itemsToRejectRef.current = null;
    },
    showSnackbar,
  });

  const handleOpenRejectModal = (items, itemName = null) => {
    const itemsArray = Array.isArray(items) ? items : [items];
    itemsToRejectRef.current = itemsArray;
    openRejectModal(items, itemName);
  };

  const handleSelectBatch = (batchId) => {
    setSelectedBatchIds((prevSelected) =>
      prevSelected.includes(batchId)
        ? prevSelected.filter((id) => id !== batchId)
        : [...prevSelected, batchId],
    );
  };

  const handleSelectAll = (event) => {
    const unpublishedBatches = availableBatches.filter(
      (batch) => !batch.isPublished,
    );
    if (event.target.checked) {
      setSelectedBatchIds(unpublishedBatches.map((batch) => batch._id));
    } else {
      setSelectedBatchIds([]);
    }
  };

  const numSelected = selectedBatchIds.length;
  const numUnpublished = availableBatches.filter(
    (batch) => !batch.isPublished,
  ).length;

  const handleAccordionToggle = (batchTitle) => (event) => {
    event.stopPropagation();
    setMultipleSelectedJobs([]);
    setExpandedBatch((prev) => (prev === batchTitle ? null : batchTitle));
  };

  const handleMenuClick = (event, job) => {
    setAnchorEl(event.currentTarget);
    setSelectedJob(job);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleEditJob = () => {
    setOpenModal(true);
    handleCloseMenu();
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const updateJob = async (job) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.put(
        `${process.env.REACT_APP_URL}/jobs/updateJob/${job._id}`,
        job,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      return response.data.data; // Return the updated job data
    } catch (error) {
      console.error("Error updating job:", error);
      return null;
    }
  };

  const handleSaveJob = async (updatedFields) => {
    if (!selectedJob || !selectedJob._id) {
      console.error("Selected job does not have an id");
      return;
    }

    const updatedJob = await updateJob(updatedFields);
    if (updatedJob) {
      // Update the parent state
      updateJobInParent(updatedJob);

      // Update the local state (availableBatches)
      const updatedBatches = availableBatches.map((batch) => ({
        ...batch,
        jobs: batch.jobs.map((job) =>
          job._id === updatedJob._id ? updatedJob : job,
        ),
      }));
      setAvailableBatches(updatedBatches);

      handleCloseModal();
    }
  };

  // Open duplicate dialog
  const handleDuplicateJob = () => {
    if (!selectedJob) return;

    let targetBatchId = null;
    availableBatches?.forEach((batch) => {
      if (batch?.jobs?.some((job) => job?._id === selectedJob?._id)) {
        targetBatchId = batch?._id;
      }
    });

    setDuplicatingJob(selectedJob);
    setDuplicatingBatchId(targetBatchId);
    setOpenAddJob(true);
    handleCloseMenu();
  };

  // Handle job created from duplicate - fetches only the specific batch
  const handleJobCreated = async (newJobData, originalJobId, errorMessage) => {
    if (errorMessage) {
      if (showSnackbar) {
        showSnackbar({
          open: true,
          message: errorMessage || "Failed to create job",
          severity: "error",
        });
      }
      setDuplicatingJob(null);
      setDuplicatingBatchId(null);
      return;
    }

    if (!duplicatingBatchId) {
      setDuplicatingJob(null);
      setDuplicatingBatchId(null);
      return;
    }

    try {
      const updatedBatch = await fetchBatchById(duplicatingBatchId);

      if (updatedBatch) {
        setAvailableBatches((prevBatches) =>
          prevBatches?.map((batch) => {
            if (batch?._id === duplicatingBatchId) {
              const currentBatch = prevBatches?.find(
                (b) => b?._id === duplicatingBatchId,
              );
              return {
                ...updatedBatch,
                isPublished:
                  currentBatch?.isPublished ||
                  updatedBatch?.isPublished ||
                  false,
              };
            }
            return batch;
          }),
        );

        if (showSnackbar) {
          showSnackbar({
            open: true,
            message: "Job duplicated successfully",
            severity: "success",
          });
        }
      }
    } catch (error) {
      console.error("Error updating batch after duplication:", error);
      if (showSnackbar) {
        showSnackbar({
          open: true,
          message: "Failed to update batch after duplication",
          severity: "error",
        });
      }
    } finally {
      setDuplicatingJob(null);
      setDuplicatingBatchId(null);
    }
  };

  // Handle dialog close
  const handleAddJobClose = () => {
    setOpenAddJob(false);
    if (duplicatingJob && duplicatingBatchId) {
      setTimeout(() => {
        setDuplicatingJob(null);
        setDuplicatingBatchId(null);
      }, 1000);
    } else {
      setDuplicatingJob(null);
      setDuplicatingBatchId(null);
    }
  };

  useEffect(() => {
    if (availableJobs && availableBatches.length > 0) {
      // Map and initialize batches
      // const updatedBatches = availableBatches.map((batch) => ({
      //   ...batch,
      //   // jobs: [], // Initialize jobs array for each batch
      // }));
      // Group jobs under their respective batches
      // availableJobs.forEach((job) => {
      //   const batch = updatedBatches.find(
      //     (batch) => batch._id === job.batchOfJobsForInstallationPartnerId
      //   );
      //   if (batch) {
      //     batch.jobs.push(job);
      //   }
      // });
      // Calculate dateRange and total payment for each batch
      const batchesWithDateRangesAndPayments = availableBatches.map((batch) => {
        let totalPayment = 0;
        let jobDates = [];
        if (batch.jobs && batch.jobs.length > 0) {
          // Calculate total payment by summing all job payments
          totalPayment = batch.jobs.reduce(
            (sum, job) => sum + (job.paymentAmount || 0),
            0,
          );
          // Get all job dates
          jobDates = batch.jobs
            .filter((job) => job.jobStartingDate && job.jobCompletionDate)
            .map((job) => ({
              start: new Date(job.jobStartingDate),
              end: new Date(job.jobCompletionDate),
            }));
        }
        // Format date range if we have dates
        let formattedDateRange = "No Dates Available";
        if (jobDates.length > 0) {
          const earliestStartDate = new Date(
            Math.min(...jobDates.map((date) => date.start)),
          );
          const latestEndDate = new Date(
            Math.max(...jobDates.map((date) => date.end)),
          );
          formattedDateRange = `${earliestStartDate.toLocaleDateString()} - ${latestEndDate.toLocaleDateString()}`;
        }
        return {
          ...batch,
          dateRange: formattedDateRange,
          totalPayment,
        };
      });
      // Update batches only if there is a change
      setAvailableBatches((prevBatches) => {
        const prevBatchesString = JSON.stringify(prevBatches);
        const updatedBatchesString = JSON.stringify(
          batchesWithDateRangesAndPayments,
        );
        // Only update state if batches have changed
        if (prevBatchesString !== updatedBatchesString) {
          return batchesWithDateRangesAndPayments;
        }
        return prevBatches;
      });
    }
  }, [availableJobs, availableBatches]);

  const handleMultipleSelectAll = (batchId, checked) => {
    const batch = availableBatches.find((batch) => batch._id === batchId);

    if (!batch) return;

    const validJobs = batch.jobs?.filter((job) => job.status !== 2) || [];

    if (checked) {
      setMultipleSelectedJobs(validJobs);
    } else {
      setMultipleSelectedJobs([]);
    }
  };

  const handleMultipleSelectJob = (job) => {
    setMultipleSelectedJobs((prevSelected) => {
      const isAlreadySelected = prevSelected.find(
        (item) => item._id === job._id,
      );

      if (isAlreadySelected) {
        return prevSelected.filter((item) => item._id !== job._id);
      } else {
        return [...prevSelected, job];
      }
    });
  };

  const searchData = useMemo(() => {
    const result = [];

    availableBatches.forEach((batch) => {
      batch.jobs?.forEach((job) => {
        result.push({
          id: job._id,
          storeName: job.storeName,
          batchTitle: batch.batchTitle,
          targetId: batch._id,
          subText: `Batch: ${batch.batchTitle}`,
        });
      });
    });

    return result;
  }, [availableBatches]);

  return (
    <>
      <Grid ref={containerRef} className={`${styles.scrollableContainer}`}>
        <div className="mx-3 py-2 sticky top-0 z-20 bg-white">
          <StoreSearch
            data={searchData}
            searchKey="storeName"
            placeholder="Search Store Name"
            containerRef={containerRef}
            targetRefs={batchRefs}
            onSelect={(item) => {
              setExpandedBatch(item.batchTitle);
            }}
          />
        </div>
        {isAllBatchesLoading ? (
          <div className={styles.noJobsStyle}>
            <CircularProgress />
          </div>
        ) : availableBatches?.length > 0 ? (
          <>
            {numUnpublished > 0 && (
              <Box display="flex" alignItems="center" mb={2} ml={2}>
                <Checkbox
                  indeterminate={
                    numSelected > 0 && numSelected < numUnpublished
                  }
                  checked={numUnpublished > 0 && numSelected === numUnpublished}
                  onChange={handleSelectAll}
                  color="primary"
                />
                <Typography variant="body2">
                  {numSelected} of {numUnpublished} unpublished batches selected
                </Typography>
              </Box>
            )}

            {availableBatches.map((batch, index) => {
              const areAllJobsRejected =
                batch.jobs?.length > 0 &&
                batch.jobs.every((job) => job.status === 2);
              return (
                <Grid
                  ref={(el) => (batchRefs.current[batch._id] = el)}
                  item
                  xs={12}
                  md={12}
                  key={index}
                  my={1}
                  mx={2}
                >
                  <Accordion expanded={expandedBatch === batch.batchTitle}>
                    <AccordionSummary
                      expandIcon={
                        <IconButton
                          onClick={handleAccordionToggle(batch.batchTitle)}
                        >
                          <ExpandMoreIcon />
                        </IconButton>
                      }
                      aria-controls={`panel-${index}-content`}
                      id={`panel-${index}-header`}
                    >
                      <div className="flex items-center justify-between p-4 rounded-lg bg-white w-full mx-auto">
                        {/* Section 1: Batch Title */}
                        <div className="flex items-center">
                          {!batch.isPublished &&
                          expandedBatch !== batch.batchTitle ? (
                            <Checkbox
                              checked={selectedBatchIds.includes(batch._id)}
                              onChange={() => handleSelectBatch(batch._id)}
                              color="primary"
                              onClick={(e) => e.stopPropagation()}
                            />
                          ) : (
                            <div style={{ width: "42px" }} /> // Placeholder for consistent spacing
                          )}
                          <h2 className={styles.batchTitle}>
                            {batch.batchTitle}
                          </h2>
                        </div>

                        <div className={styles.chipContainer}>
                          <Chip
                            label={
                              batch.isPublished ? "Published" : "Not Published"
                            }
                            sx={{
                              backgroundColor: batch.isPublished
                                ? "#D0F4FF"
                                : "#FFDFDF", // Custom background color based on adminStatus
                              color: batch.isPublished ? "#093EBC" : "#8C0909", // Custom text color based on adminStatus
                            }}
                          />
                          <Chip
                            label={`Timeline: ${moment(
                              batch?.jobStartingDate,
                            ).format("DD MMM YY")} - ${moment(
                              batch?.jobCompletionDate,
                            ).format("DD MMM YY")}`}
                            className={styles.chip}
                          />
                          {/* <Chip
                          label={
                            batch?.dateRange
                              ? `Allotted Timeline: ${moment(
                                  batch.dateRange.split("-")[0].trim(),
                                  "DD/MM/YYYY"
                                ).format("DD MMM YY")} - ${moment(
                                  batch.dateRange.split("-")[1].trim(),
                                  "DD/MM/YYYY"
                                ).format("DD MMM YY")}`
                              : "No date range available"
                          }
                          className={styles.chip}
                        /> */}

                          <Chip
                            label={
                              <span>
                                Batch Payment: ₹{batch?.paymentAmount}
                              </span>
                            }
                            className={styles.chips}
                          />
                          <div>
                            <Chip
                              label={"Jobs:" + batch.jobs?.length || 0}
                              className={styles.chip}
                            />
                          </div>
                          {/* User Info */}
                          {/* <Chip label={batch.contact} className={styles.chip} /> */}

                          {/* Status Badge */}
                          {/* <TableCell className={styles.tableCell}>
                        <Chip
                          label={
                            batch.jobs?.some((job) => job.status === 0)
                              ? "pending"
                              : batch.status === 1
                                ? "complete"
                                : batch.status
                          }
                          className={
                            batch.jobs?.some((job) => job.status === 0)
                              ? styles.pending
                              : batch.status === 1
                                ? styles.amountPaid
                                : ""
                          }
                          sx={{
                            textDecoration: "none", // Remove underline
                          }}
                        />
                      </TableCell> */}

                          {/* <Chip
                        label={batch.status === 0 ? "Pending" : batch.status}
                        className={styles.pending}
                      /> */}

                          {/* Ellipsis Button */}
                          <button
                            className="text-gray-400 hover:text-gray-600 text-xl rounded-full px-4 py-1 hover:bg-gray-100"
                            onClick={(e) => {
                              e.stopPropagation();
                              setBatchMenuAnchorEl(e.currentTarget);
                              setSelectedBatch(batch);
                            }}
                          >
                            ⋮
                          </button>
                        </div>
                      </div>
                    </AccordionSummary>
                    <AccordionDetails className={styles.accordionDetails}>
                      {/* Render Job Details Table */}
                      <Box className={`${styles.scrollableBox}`}>
                        <TableContainer component={Paper}>
                          <Table>
                            <TableHead>
                              <TableRow className={styles.tableHeader}>
                                <TableCell padding="checkbox">
                                  <Checkbox
                                    disabled={
                                      batch.jobs?.length === 0 ||
                                      areAllJobsRejected
                                    }
                                    checked={
                                      batch.jobs?.length > 0 &&
                                      batch.jobs.every((job) =>
                                        multipleSelectedJobs.some(
                                          (selected) =>
                                            selected._id === job._id,
                                        ),
                                      )
                                    }
                                    onChange={(e) => {
                                      e.stopPropagation();
                                      handleMultipleSelectAll(
                                        batch._id,
                                        e.target.checked,
                                      );
                                    }}
                                  />
                                </TableCell>
                                <TableCell className={styles.tableCell}>
                                  CITY
                                </TableCell>
                                <TableCell className={styles.tableCell}>
                                  ADDRESS
                                </TableCell>
                                <TableCell className={styles.tableCell}>
                                  STORE NAME
                                </TableCell>
                                <TableCell className={styles.tableCell}>
                                  STORE MANAGER
                                </TableCell>
                                <TableCell className={styles.tableCell}>
                                  PRODUCT TYPE
                                </TableCell>
                                <TableCell className={styles.tableCell}>
                                  JOB PAY
                                </TableCell>
                                <TableCell className={styles.tableCell}>
                                  ACTION
                                </TableCell>
                                {/* <TableCell className={styles.tableCell}>KAM APPROVAL</TableCell>
                            <TableCell className={styles.tableCell}>CLIENT APPROVAL</TableCell> */}
                                {/* <TableCell className={styles.tableCell}>JOB STATUS</TableCell> */}
                                {/* <TableCell className={styles.tableCell}>IP PAY</TableCell> */}
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {batch.jobs?.map((row, index) => (
                                <TableRow key={index}>
                                  <TableCell padding="checkbox">
                                    {row.status != 2 && (
                                      <Checkbox
                                        disabled={row.status === 2}
                                        checked={multipleSelectedJobs?.some(
                                          (item) => item._id === row._id,
                                        )}
                                        onChange={() =>
                                          handleMultipleSelectJob(row)
                                        }
                                      />
                                    )}
                                  </TableCell>
                                  <TableCell className={styles.tableCell}>
                                    <div className={styles.sharedTextStyle}>
                                      {row.city}
                                    </div>
                                  </TableCell>
                                  <TableCell className={styles.tableCell}>
                                    <div className={styles.sharedTextStyle}>
                                      {row.address}
                                    </div>
                                    <div className={styles.address2}>
                                      {row.city}, {row.state}, {row.zipCode}
                                    </div>
                                  </TableCell>
                                  <TableCell className={styles.tableCell}>
                                    <div className={styles.sharedTextStyle}>
                                      {row.storeName}
                                    </div>
                                  </TableCell>

                                  <TableCell className={styles.tableCell}>
                                    <div className={styles.sharedTextStyle}>
                                      {row.storeOwnerName}
                                    </div>
                                    <div className={styles.sharedTextStyle}>
                                      {row.storeOwnerPhoneNumber}
                                    </div>
                                  </TableCell>
                                  {/* <TableCell className={styles.tableCell}>
                                  <div className={styles.sharedTextStyle}>
                                    {row.storeOwnerPhoneNumber}
                                  </div>
                                </TableCell> */}
                                  <TableCell className={styles.tableCell}>
                                    <div className={styles.sharedTextStyle}>
                                      {row?.productId?.productType || "N/A"}
                                    </div>
                                  </TableCell>

                                  <TableCell className={styles.tableCell}>
                                    <div className={styles.sharedTextStyle}>
                                      ₹{row.paymentAmount}
                                    </div>
                                  </TableCell>
                                  <TableCell className={styles.tableCell}>
                                    {row.status != 2 ? (
                                      <Tooltip title="Actions">
                                        <IconButton
                                          onClick={(event) => {
                                            handleMenuClick(event, row);
                                          }}
                                          sx={{
                                            "&:hover": {
                                              backgroundColor: "transparent",
                                              "& .MuiSvgIcon-root": {
                                                color: (theme) =>
                                                  theme.palette.action.disabled,
                                              },
                                            },
                                          }}
                                        >
                                          <MoreVertIcon />
                                        </IconButton>
                                      </Tooltip>
                                    ) : (
                                      <Tooltip title="No actions available">
                                        <span>
                                          <IconButton disabled>
                                            <MoreVertIcon color="disabled" />
                                          </IconButton>
                                        </span>
                                      </Tooltip>
                                    )}
                                  </TableCell>
                                  {/* <TableCell className={styles.tableCell}>
                                <div className={styles.sharedTextStyle}>{row.kamApproval}</div>
                              </TableCell> */}
                                  {/* <TableCell className={styles.tableCell}>
                                <div className={styles.sharedTextStyle}>{row.clientApproval}</div>
                              </TableCell> */}
                                  {/* <TableCell className={styles.tableCell}>
    
                                <Chip
                                  label={
                                   row.status === 0
                                      ? "pending"
                                      : row.status === 1
                                        ? "complete"
                                        : row.status
                                  }
                                  className={
                                    row.status === 1
                                      ? styles.amountPaid
                                      : row.status === 0
                                        ? styles.pending
                                        : ""
                                  }
                                />
                              </TableCell> */}

                                  {/* <TableCell className={styles.tableCell}>
                                <Chip
                                  label={
                                    row.status === 0
                                      ? "pending"
                                      : row.status === 1
                                        ? "paid"
                                        : row.status
                                  }
                                  className={
                                    row.status === 1
                                      ? styles.amountPaid
                                      : row.ipPay === "paid"
                                        ? styles.amountPaid
                                        : styles.pending
                                  }
                                />
    
                              </TableCell> */}
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </Box>
                    </AccordionDetails>
                    {/* <BatchActions /> */}
                  </Accordion>
                  <Menu
                    anchorEl={batchMenuAnchorEl}
                    open={Boolean(batchMenuAnchorEl)}
                    onClose={() => {
                      setBatchMenuAnchorEl(null);
                      setSelectedBatch(null);
                    }}
                  >
                    <MenuItem
                      onClick={() => {
                        setOpenModalToUpdateBatch(true);
                        setDetailsOfBatchSelected(selectedBatch);
                        setBatchMenuAnchorEl(null);
                      }}
                    >
                      Edit Batch
                    </MenuItem>

                    <MenuItem
                      disabled={!multipleSelectedJobs.length || isProcessing}
                      onClick={() => {
                        handleOpenRejectModal(
                          multipleSelectedJobs,
                          `${multipleSelectedJobs.length} jobs`,
                        );
                        setBatchMenuAnchorEl(null);
                      }}
                    >
                      Reject Selected ({multipleSelectedJobs.length})
                    </MenuItem>
                  </Menu>
                </Grid>
              );
            })}
          </>
        ) : (
          <div className={styles.noJobsStyle}>
            <Typography
              variant="h6"
              align="center"
              className={`${styles.noJobsBox} ${styles.noJobsText}`}
              style={{ margin: "2rem 0" }}
            >
              No batches available
            </Typography>
          </div>
        )}
      </Grid>
      {openModalToUpdateBatch && (
        <ModalToUpdateBatches
          openModal={openModalToUpdateBatch}
          setOpenModalToUpdateBatch={setOpenModalToUpdateBatch}
          batch={detailsOfBatchSelected}
          fetchAllJobsBasedOnCampaignId={fetchAllJobsBasedOnCampaignId}
          setAvailableBatches={setAvailableBatches}
          fetchAllBatchesBasedOnCampaignId={() =>
            fetchAllBatchesBasedOnCampaignId()
          }
          onIPAssignmentSuccess={onIPAssignmentSuccess}
          fetchJobsData={fetchAllJobsBasedOnCampaignId}
          // Add these new props
          setAcceptedBatches={setAcceptedBatches}
          setIsNotAccepted={setIsNotAccepted}
          onBatchUpdate={(updatedBatch) => {
            setAvailableBatches((prev) =>
              prev.map((b) => (b._id === updatedBatch._id ? updatedBatch : b)),
            );
            // Also update the local detailsOfBatchSelected if it's the same batch
            if (detailsOfBatchSelected?._id === updatedBatch._id) {
              setDetailsOfBatchSelected(updatedBatch);
            }
          }}
        />
      )}

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleCloseMenu}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <MenuItem onClick={handleEditJob}>Edit Job</MenuItem>
        <MenuItem onClick={handleDuplicateJob}>Duplicate Job</MenuItem>
        {selectedJob?.status != 2 && (
          <MenuItem
            onClick={() => {
              handleOpenRejectModal(
                selectedJob,
                selectedJob?.storeName || "Job",
              );
              handleCloseMenu();
            }}
            disabled={isProcessing}
          >
            {isProcessing ? "Processing..." : "Reject Job"}
          </MenuItem>
        )}
      </Menu>
      <ModalToOpenEditJobs
        open={openModal}
        handleClose={handleCloseModal}
        selectedJob={selectedJob}
        setSelectedJob={setSelectedJob}
        handleSaveJob={handleSaveJob}
      />
      {openAddJob && (
        <AddJobDialog
          open={openAddJob}
          onClose={handleAddJobClose}
          campaignId={id}
          selectedJob={duplicatingJob}
          soDetails={soDetails}
          categoryData={categoryData}
          productDetails={productDetails}
          fetchAllBatchesBasedOnCampaignId={() => {}}
          createJobFrom={"batches"}
          setAnchorEl={setAnchorEl}
          jobForWhichService="Recce"
          onJobCreated={handleJobCreated}
          showError={(errorMessage) => {
            if (showSnackbar) {
              showSnackbar({
                open: true,
                message: errorMessage || "Failed to create job",
                severity: "error",
              });
            }
          }}
        />
      )}

      <RejectModal
        open={rejectDialogOpen}
        onClose={closeRejectModal}
        onConfirm={handleRejectConfirm}
        title="Reject Job"
        isProcessing={isProcessing}
        confirmButtonText="Reject"
        cancelButtonText="Cancel"
        placeholder="Enter rejection reason..."
        rows={4}
        itemName={itemInfo.name}
        itemCount={itemInfo.count}
      />
    </>
  );
};

export default AllBatches;
